import { render } from "./paneFour.vue?vue&type=template&id=543ae49b&scoped=true"
import script from "./paneFour.vue?vue&type=script&lang=js"
export * from "./paneFour.vue?vue&type=script&lang=js"

import "./paneFour.vue?vue&type=style&index=0&id=543ae49b&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543ae49b"]])

export default __exports__